import * as React from 'react'

import { TButtonVariantProps } from '~ui/components/buttons/Button/buildButtonVariantProps'
import { Button, SIZE_PADDINGS } from '~ui/components/buttons/Button/Button'
import { Text } from '~ui/components/typography/Text/Text'
import { TTextFontSize } from '~ui/styleGuide/fontStyles'

type TTextProps = OmitSafe<PropsOf<typeof Text>, 'fontSize'>
type TButtonProps = TButtonVariantProps &
  OmitSafe<PropsOf<typeof Button>, 'variant' | 'bgColor' | 'borderContrast' | 'size'>

type TProps = RequiredChildren &
  TButtonProps & {
    textProps?: TTextProps
  }

const BUTTON_SIZE: keyof typeof SIZE_PADDINGS = `large`

export const BUTTON_LARGE_VERTICAL_PADDING = SIZE_PADDINGS[BUTTON_SIZE].vertical
export const BUTTON_LARGE_FONT_SIZE: TTextFontSize = `m16`

/**
 * Button of large size with regular-size text
 */
export const ButtonLarge: React.FC<TProps> = ({ children, textProps, ...buttonProps }) => {
  return (
    <Button size={BUTTON_SIZE} {...buttonProps}>
      <Text fontStyle={`upperCase`} fontSize={BUTTON_LARGE_FONT_SIZE} {...textProps}>
        {children}
      </Text>
    </Button>
  )
}
